export const isValidYoutubeUrl = (url: string): boolean => {
  if (!url) return true
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  return youtubeRegex.test(url)
}


export const extractYoutubeVideoId = (url: string): string | null => {
  const pattern = /(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  const match = url.match(pattern)
  return match ? match[2] : null
}

export const extractYoutubeLinks = (text: string): string[] => {
  const pattern =
    /(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/g
  const matches: RegExpMatchArray | null = text.match(pattern)
  const videoIds: string[] = matches
    ? matches.map((match) => match.split('=')[1])
    : []
  const youtubeLinks: string[] = videoIds.map(
    (videoId) => `https://www.youtube.com/watch?v=${videoId}`
  )
  return youtubeLinks
}
